import {
  GET_CAMPAIGNS,
  GET_CAMPAIGN,
  SET_CAMPAIGN
} from '../Actions/campaignActions'

const initialState = {
  campaign: {},
  campaigns: [],
  newCampaignId: null // campaign id of campaign type
}

const campaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CAMPAIGNS:
      return {
        ...state,
        campaigns: action.campaigns
      }
    case GET_CAMPAIGN:
      return {
        ...state,
        campaign: action.campaign
      }
    case SET_CAMPAIGN:
      return {
        ...state,
        newCampaignId: action.newCampaignId
      }
    default:
      return state
  }
}

export default campaignReducer
